/* eslint-disable no-unused-vars */
import AuthService from 'top20common/distribution/services/auth';
import CandidatesService from 'top20common/distribution/services/candidates';
import cookies from 'top20common/distribution/services/cookies';
import LanguagesService from 'top20common/distribution/services/languages';
import ProfilesService from 'top20common/distribution/services/profiles';
import SettingsService from 'top20common/distribution/services/settings';
import commonActions from 'top20common/distribution/store/actions';

import {
  CHANGE_COMPANIES_OF_INTEREST_REQUEST,
  CHANGE_COMPANIES_OF_INTEREST_SUCCESS,
  CHANGE_FIELD_JOB_FORM,
  CHANGE_NEW_PASSWORD_FIELD,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_SAVED_SEARCH,
  CHANGE_VALUE_FIELD,
  DELETE_SAVED_SEARCH,
  FETCH_COMPANIES_OF_INTEREST,
  GET_SAVED_SEARCHES_LIST,
  LOGIN_ERROR,
  LOGIN_REQUEST,
  RESET_ALL_FIELDS,
  RESET_PASSWORD_REQUEST,
  SHIFT_PASSWORD_COMPONENT
} from './constants';
import commonUtils from "top20common/distribution/utils";

export default {
  ...commonActions,
  async [FETCH_COMPANIES_OF_INTEREST](context) {
    try {
      context.commit(CHANGE_COMPANIES_OF_INTEREST_REQUEST);
      const response = await SettingsService.fetchSettings();
      context.commit(CHANGE_COMPANIES_OF_INTEREST_SUCCESS, response.data);
      const coi = response.data.result.companies_of_interest || [];
      context.commit('mutateCountSavedCompaniesOfInterestState', coi.length);
    } catch (error) {
      context.commit('mutateCompaniesOfInterestErrorState', error.response.data.errors.companies_of_interest);
    }
  },
  editCompaniesOfInterestInBackgroundAction(context, coiNames) {
    return new Promise((resolve, reject) => {
      SettingsService.changeSettings({companies_of_interest: coiNames})
        .then(response => {
          context.commit('mutateCompaniesOfInterestErrorState', null);
          const coi = response.data.result.companies_of_interest || [];
          context.commit('mutateCountSavedCompaniesOfInterestState', coi.length);
          resolve(response);
        })
        .catch(error => {
          context.commit('mutateCompaniesOfInterestErrorState', error.response.data.errors.companies_of_interest);
          reject(error.response.data.errors);
        });
    });
  },
  clearErrors(context) {
    context.commit('clearErrors');
  },
  loginWithLinkedIn(context, code) {
    return new Promise((resolve, reject) => {
      AuthService.loginWithLinkedInByCode({code})
        .then(response => {
          context.dispatch('handlePreLoginDataChanges', response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error.response.data.errors.non_field_errors[0]);
        });
    });
  },
  loginUser(context, {email, password, scope, vm}) {
    context.commit(LOGIN_REQUEST);
    return new Promise((resolve, reject) => {
      AuthService.login({email, password})
        .then(response => {
          let decoded = commonUtils.parsePayloadFromJWT(response.data.token);
          const scopes = decoded.scopes || [];
          if (scopes.includes(scope)) {
            return response;
          }
          const errors = {non_field_errors: [vm.$gettext("Unable to log in with provided credentials.")]};
          return Promise.reject({response: {data: {errors}, status: 400}});
        })
        .then(response => {
          context.dispatch('handlePreLoginDataChanges', response.data);
          resolve(response);
        })
        .catch(error => {
          context.commit(LOGIN_ERROR, error.response.data.errors);
          vm.$mam.trackLoginError(error.response);
          reject(error);
        });
    });
  },
  handlePreLoginDataChanges(context, data) {
    const {token, user} = data;
    AuthService.preLoginCleanup();
    context.commit('loginSuccess', data);
    context.commit('mutateUserTokenState', token);

    cookies.saveExpireDays(context.state.loginForm.isRemember ? 14 : 7);
    cookies.set('user', user.pk);
    AuthService.updateLocalStorage(data);
    context.dispatch('handlePreLoginLanguageChanges', user.language);
    context.commit('clearErrors');
  },
  handlePreLoginLanguageChanges(context, userLanguage) {
    let localLanguage = localStorage.getItem('preLoginLanguageChangedTo');
    localStorage.removeItem('preLoginLanguageChangedTo');

    if (localLanguage && localLanguage !== userLanguage) {
      context.dispatch('changeUserPreferencesAction', {
        value: {language: LanguagesService.getLanguageParam(localLanguage)}
      });
    } else {
      localStorage.setItem('language', LanguagesService.getLanguageLocale(userLanguage));
    }
  },
  changePassword(context, options) {
    context.commit(CHANGE_PASSWORD_REQUEST, true);
    AuthService.changePassword(options)
      .then(response => {
        context.commit(CHANGE_PASSWORD_SUCCESS, response.data);
      })
      .catch(error => {
        context.commit(CHANGE_PASSWORD_FAIL, error.response.data.errors);
      });
  },
  confirmEmail(context, key) {
    AuthService.confirmEmail(key)
      .then(() => {
        context.commit('emailConfirmationSuccess');
      })
      .catch(response => {
        context.commit('emailConfirmationError', response.response.data.errors);
      });
  },
  resetPassword(context, {uid, token, password}) {
    AuthService.resetPassword(uid, token, password)
      .then(response => {
        context.commit('passwordResetSuccess');
      })
      .catch(response => {
        context.commit('passwordResetError', response.response.data);
      });
  },
  requestPasswordReset(context, email) {
    context.commit(RESET_PASSWORD_REQUEST);
    AuthService.requestPasswordReset(email)
      .then(response => {
        context.commit('resetPasswordFormUpdate', false);
      })
      .catch(e => {
        context.commit('resetPasswordFormUpdate', {value: true, errors: e.response.data.errors.email});
      });
  },
  resetAllFields(context, formType) {
    context.commit(RESET_ALL_FIELDS, formType);
  },
  shiftPasswordComponent(context, value) {
    context.commit(SHIFT_PASSWORD_COMPONENT, value);
  },
  changeFieldPasswordForm(context, value) {
    context.commit(CHANGE_NEW_PASSWORD_FIELD, value);
  },
  fetchSavedSearchesAction(context) {
    context.commit(CHANGE_SAVED_SEARCH, {loading: true});
    CandidatesService.getSavedSearches({limit: 1000})
      .then(response => {
        context.commit(GET_SAVED_SEARCHES_LIST, response.data.results);
        context.commit(CHANGE_SAVED_SEARCH, {loading: false});
      })
      .catch(errors => {
        context.commit(CHANGE_SAVED_SEARCH, {loading: false});
      });
  },
  getSavedSearchesInBackgroundAction(context) {
    return CandidatesService.getSavedSearches({limit: 1000}).then(response => {
      context.commit(GET_SAVED_SEARCHES_LIST, response.data.results);
    });
  },
  [CHANGE_FIELD_JOB_FORM](context, value) {
    context.commit(CHANGE_VALUE_FIELD, value);
  },
  deleteSearch(context, data) {
    context.commit(CHANGE_SAVED_SEARCH, {loading: true});
    CandidatesService.deleteSearch(data.id)
      .then(response => {
        context.commit(DELETE_SAVED_SEARCH, data.id);
        context.commit(CHANGE_SAVED_SEARCH, {loading: false});
        data.callback();
      })
      .catch(errors => {
        context.commit(CHANGE_SAVED_SEARCH, {loading: false});
      });
  },
  fetchFiltersAction(context, params = {}) {
    context.commit('mutateFiltersState', {loading: true});
    return new Promise((resolve, reject) => {
      CandidatesService.fetchOptions(params)
        .then(response => {
          let {salary_max, salary_min, salary_range_indexes, ...filters} = response.data;
          context.commit('initialFiltersMutation', filters);
          context.commit('markTop5GroupMutation', 'cities');
          context.commit('markTop5GroupMutation', 'industries');
          resolve(response);
        })
        .catch(error => {
          context.commit('mutateFiltersState', {loading: false, all: null, error: error.response.data.errors});
        });
    });
  },
  changeAccountSettings(context, data) {
    return SettingsService.changeSettings(data);
  },
  getReferrerProfileAction(context, referralCode) {
    return new Promise((resolve, reject) => {
      ProfilesService.getReferrerProfileByCode(referralCode)
        .then(response => {
          context.commit('setReferrerProfileState', response.data);
          resolve();
        })
        .catch(() => {});
    });
  }
};
